export default __webpack_public_path__ + "static/media/python.2a77355f.svg";